import AirtableTable from "../AirtableTable";
import { Subject } from "../models";
import { airtableFields, airtableTables } from "../schema";

export class SubjectTable extends AirtableTable<Subject> {
  constructor(instance: any) {
    super(instance, airtableTables.subjects);

    this.fields = [
      airtableFields.subjects.subject, airtableFields.subjects.subjectFr, airtableFields.subjects.curriculumLinks,
      airtableFields.subjects.teachers, airtableFields.subjects.courses
    ]
  }

  getTotalSubjects = () => {
    return this.list({
      sort: [{
        field: airtableFields.subjects.subject,
        direction: "asc"
      }]
    })
  }
}
